<div class="table-header">
  @if (!disableTable) {
    <div class="btn-group">
      @if (applyAllAllowed()) {
        <button class="secondary_button" (click)="cancelSelection()">Cancel</button>
        <button class="primary_button" (click)="applyEnteredValueForSelectedRows()">Apply All</button>
      } @else {
        @if (bulkDeleteAllowed()) {
          <button class="secondary_button" (click)="deleteSelectedRows()"
                  style="display: flex;gap: 4px;align-items: flex-start;justify-content: center;height: 44px;">
            <img src="assets/icons/delete_icon.svg">
            Delete
          </button>
        }
      }
    </div>
  }
</div>

<div class="table_with_grid">
  <div class="table_container">
    @if (tableData.length == 0) {
      <app-no-data msg="{{noDataFoundErrorMsg}}"></app-no-data>
    } @else {
      <table>
        <thead>
        <tr>
          <th class="cb_th first-column-pinned" *ngIf="allowSelection">
            <input type="checkbox"
                   [checked]="isAllRecordsOfCurrentPageSelected()"
                   (change)="toggleAllRecordsOfCurrentPageSelections($event.target.checked)"
            />
          </th>
          @if (!allowSelection) {
            <th class="sl_th first-column-pinned">
              <div class="sl_th_text">SL No.</div>
            </th>
          }
          @for (header of tableHeaders; track $index) {
            <th [ngClass]="{
            'pinned': header.isPinned,
            'hidden': header.hidden
          }">
              <div class="header_content_editable_table" [ngStyle]="header.fieldInfo?.style">
                @if (header.editable && showInputFieldsOnTh) {
                  <div class="header_checkbox">
                    <input type="checkbox" (change)="selectColumns(header.label)"
                           [checked]="isSelectedColumn(header.label)">
                  </div>
                }
                <div class="header_text_with_input_box">
                  <div class="table_header_text">{{ header.displayLabel }}</div>
                  @if (header.editable && showInputFieldsOnTh) {
                    <app-editable-table-dynamic-input
                      #headerInput
                      [header]="header"
                      (updateValue)="updateColumnValue(header,$event)"
                      [disabled]="disableTable"
                    >
                    </app-editable-table-dynamic-input>
                  }
                </div>

              </div>
            </th>
          }
          <th class="table_menu_th" *ngIf="deletionAllowed"></th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let row of tableData; let rowIndex = index"
          [ngClass]="{
          'selected-row': isSelected(row),
        }"
        >
          <td class="cb_td first-column-pinned row-select-cb" *ngIf="allowSelection">
            <input
              type="checkbox"
              [id]="'record_sl_no_' + row?.uniqueId"
              [checked]="isSelected(row)"
              (change)="toggleSelection(row)"
            />
          </td>
          <td class="sl_td first-column-pinned" *ngIf="!allowSelection">
            {{ rowIndex + 1 }}
          </td>
          <td *ngFor="let header of tableHeaders" [ngClass]="{
        'pinned': header.isPinned,
        'hidden': header.hidden
        }">
            <div class="cell_content_editable_table">
              @if (header.editable || (header?.conditionalEditable ?? false)) {

                @if (header?.conditionalEditable ?? false) {
                  <div class="row_checkbox">
                    <input type="checkbox" (change)="toggleDependency(header, row)"
                           [checked]="isCellEditable(header, row)">
                  </div>
                }

                <app-editable-table-dynamic-input
                  #tableDataInput
                  [header]="header"
                  [row]="row"
                  [value]="getColumnValue(row, header, false)"
                  (updateValue)="updateValue($event, rowIndex, header)"
                  [disabled]="isCellDisabled(header, row)"
                >
                </app-editable-table-dynamic-input>
              } @else {
                {{ getColumnValue(row, header, true) }}
              }
            </div>
          </td>
          <td class="table_menu_td" *ngIf="deletionAllowed">
            <app-svg-icon [path]="'assets/icons/delete_icon.svg'" (click)="deleteRecord(row, rowIndex)"></app-svg-icon>
          </td>
        </tr>
        </tbody>
      </table>
    }

  </div>
</div>
